const NavPrimary = (function(window, $) {

    function NavPrimary(el) {
        this.header = $('.header');
        this.navHeaderItem = $(el);
        this.navContainer = $('.nav-container');
        this.navHeaderItemParent = $('.nav-container .menu-item-has-children'); // added .nav-container to avoid issues on mobile
        this.navHeaderItemNoChildren = $('.nav-container .menu-item:not(".menu-item-has-children")');
        this.navHeaderItemSecondary = $('.nav-container .menu-item-has-children .nav-link-secondary');
        this.overlay = $('.overlay-nav');
        this.timer;

        this.addEvents();
    }

    NavPrimary.prototype.addEvents = function() {
        this.navHeaderItemNoChildren.on('click', this.handleClickNoChildren.bind(this));
        this.navHeaderItemSecondary.on('click', this.handleClickChild.bind(this));
        this.navHeaderItemParent.on('mouseenter', this.mouseEnterEvents.bind(this));
        this.navHeaderItemParent.on('mouseleave', this.mouseLeaveEvents.bind(this));
    };

    NavPrimary.prototype.handleClickNoChildren = function() {
        this.overlay.fadeIn('slow');
        openPageLoader();
    }

    NavPrimary.prototype.handleClickChild = function() {
        openPageLoader();
    }

    NavPrimary.prototype.mouseEnterEvents = function(el) {
        // prevent immediate hovering effect with a timeout               
        this.timer = setTimeout(function () {
            this.overlay.fadeIn('fast');
            this.navContainer.addClass('nav-active');
            this.header.attr('data-nav-state', 'navbar-open'); // set a state when the navbar child menu is open
            $(el.target).closest('.nav-link-primary').addClass('child-list-open');
        }.bind(this), 250);
    }

    NavPrimary.prototype.mouseLeaveEvents = function() {
        clearTimeout(this.timer);
        this.overlay.fadeOut('fast');
        this.navContainer.removeClass('nav-active');
        this.header.removeAttr('data-nav-state'); // remove the state and the total attr when the navbar child menu is closed again from the MousenterEvents function
        this.navHeaderItemParent.find('.nav-link-primary').removeClass('child-list-open');
    }

    return NavPrimary;

}(window, jQuery));

export {NavPrimary};